export default function iconTextDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: true,
		templateUrl: "./components/icon/icon-text-template.html",
		scope: {
			icon: "@"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function () {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
			};
		}
	};
}
